import { ToolSet } from "@app/tool/model/toolSet.model";
import { Tool } from "@app/tool/model/tool.model";

export class ToolBulkUpdate {

    public tools: Array<ToolSet | Tool>;
    public changes: any;

    constructor(tbu: any = {}) {
        this.tools = tbu.tools || 0;
        this.changes = tbu.changes || '';
    }
}
